module.exports = __webpack_public_path__ + "img/HZGB12-5w.3aec4d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/HZGB12-5w.png
// module id = ZtLP
// module chunks = 0